import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardSingleTop from "../card-single-top";
import { useSelector } from "react-redux";
import { selectCars } from "../../../redux/car/car-slice";
import Empty from "../../empty-message/empty";

const FillCarsSlider = () => {
  const cars = useSelector(selectCars);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3, // دسکتاپ
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992, // تبلت
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 576, // موبایل
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="container my-4">
      {cars.length === 0 ? (
        <Empty />
      ) : (
        <Slider {...settings}>
          {cars.map((car) => (
            <div key={car.id} className="px-2 h-100">
              <CardSingleTop
                car={car}
                img={car.imageUrl || "/default-avatar.png"}
              />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default FillCarsSlider;
